import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom"; // To access dynamic route parameters
import axios from "axios";
import config from "../../config";
import io from "socket.io-client"; // Import socket.io-client
import { QRCodeCanvas } from "qrcode.react"; // Import QRCodeCanvas from qrcode.react
import { Helmet } from "react-helmet";

const EventDetail = () => {
  const { eventUrlSlug } = useParams(); // Get the event_url_slug from the URL
  const [event, setEvent] = useState(null);
  const [adsPerPost, setAdsPerPost] = useState(0);
  const [currentEventId, setCurrentEventId] = useState("");
  const [posts, setPosts] = useState([]); // State to hold fetched posts
  const [groupAds, setGroupAds] = useState([]);
  const [groupAdsPost, setGroupAdsPost] = useState([]);
  const [postsAndAds, setPostsAndAds] = useState([]); // State to hold fetched posts
  const [columnsPosts, setColumnsPosts] = useState([]); // State to hold fetched posts
  const [scripts, setScripts] = useState([]);
  const [insertedScriptIds, setInsertedScriptIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPost, setSelectedPost] = useState({
    person_name: "",
    person_email_id: "",
    person_city: "",
    caption: "",
    media_url: "",
    thumbnail_media_url: "",
    media_file_type: "",
    created_at: "",
  });

  const eventFormUrl = `${window.location.origin}/event-form/${eventUrlSlug}`;
  const eventPageUrl = `${window.location.origin}/event/${eventUrlSlug}`;

  // Helper function to split posts into columns
  const getColumnPosts = () => {
    const columns = [[], [], [], []]; // Four columns for posts

    postsAndAds.forEach((post, index) => {
      if (index % 4 === 0) {
        columns[0].push(post);
      } else if (index % 4 === 1) {
        columns[1].push(post);
      } else if (index % 4 === 2) {
        columns[2].push(post);
      } else {
        columns[3].push(post);
      }
    });

    return columns;
  };

  useEffect(() => {
    const mergePostsAndAds = () => {
      const result = [];
      let postIndex = 0;
      let adIndex = 0;

      // if there are no ads
      if (groupAdsPost.length <= 0 || adsPerPost == 0) {
        setPostsAndAds(posts); // No ads, just return posts
      } else {
        // Loop through the posts and insert ads after every `adsPerPost` posts
        while (postIndex < posts.length) {
          // Add `adsPerPost` posts at a time
          for (let i = 0; i < adsPerPost; i++) {
            if (postIndex < posts.length) {
              result.push(posts[postIndex]);
              postIndex++;
            }
          }

          // Only add an ad if there are posts left after this
          if (postIndex < posts.length) {
            if (adIndex < groupAdsPost.length) {
              result.push(groupAdsPost[adIndex]);
              adIndex++;
            } else {
              // If we run out of ads, restart ads from the beginning
              adIndex = 0;
              result.push(groupAdsPost[adIndex]);
              adIndex++;
            }
          }
        }

        console.log({ result });

        // Set the final merged data to the state
        setPostsAndAds(result);
      }
    };

    // Merge posts and ads only when posts or ads change
    if (posts.length > 0 || groupAdsPost.length > 0) {
      mergePostsAndAds();
    }
  }, [posts, groupAdsPost, adsPerPost]); // Re-run when posts or groupAdsPost changes

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const eventResponse = await axios.get(
          `${config.apiBaseUrl}/api/events/event-by-slug/${eventUrlSlug}`
        );
        setEvent(eventResponse.data);
        setCurrentEventId(eventResponse.data.id);

        const postsResponse = await axios.get(
          `${config.apiBaseUrl}/api/events/get-approved-event-posts/${eventResponse.data.id}`
        );
        setPosts(postsResponse.data);

        if (eventResponse.data.ads_group_id) {
          setAdsPerPost(eventResponse.data.ads_per_post);

          const adsResponse = await axios.get(
            `${config.apiBaseUrl}/api/ads-group/get-ads-by-group-id/`,
            {
              params: { ads_group_id: eventResponse.data.ads_group_id },
            }
          );

          setGroupAds(adsResponse.data);

          // Transform the ads data into the required format
          const transformedAds = adsResponse.data.map((ad) => ({
            person_name: "", // Empty string
            person_email_id: "", // Empty string
            person_city: "", // Empty string
            caption: "", // Empty string
            media_url: ad.ads_media_url, // Take media_url from ads_media_url
            thumbnail_media_url: ad.ads_media_url, // Take thumbnail_media_url from ads_media_url
            media_file_type: "image", // Always image
            created_at: "", // Empty string
            is_ads: true, // Ad
            ad_url: ad.ad_url, // Ad
          }));

          setGroupAdsPost(transformedAds); // Set transformed data in groupAdsPost

          if (eventResponse.data.script_ids) {
            const scriptsResponse = await axios.get(
              `${config.apiBaseUrl}/api/scripts/get-scripts-per-ids`,
              {
                params: { script_ids: eventResponse.data.script_ids },
              }
            );
            setScripts(scriptsResponse.data);
          }
        }
      } catch (error) {
        console.error("Error fetching event details or posts", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();

    // Establish the connection to the backend WebSocket server
    const socketConnection = io(config.apiBaseUrl, {
      reconnectionAttempts: 5, // Number of reconnection attempts
      reconnectionDelay: 1000, // Delay between reconnections (in ms)
      reconnectionDelayMax: 5000, // Max delay between reconnections
      timeout: 20000, // Timeout before disconnecting after being unable to connect
    });

    // Event listener for successful connection
    socketConnection.on("connect", () => {
      console.log(
        "Successfully connected to backend with socket ID:",
        socketConnection.id
      );
      // Emit registerPairing after connection
      // socketConnection.emit('registerPairing', pairingId);
    });

    socketConnection.on("newEventPost", (newPost) => {
      console.log({ newPost });
      console.log({ currentEventId });
      console.log(newPost.event_id);
      if (newPost.event_id == currentEventId) {
        console.log({ newPost });
        // Add the new post to the existing posts array
        // setPosts((prevPosts) => [...prevPosts, newPost]);

        setPosts((prevPosts) => {
          const newPosts = [newPost, ...prevPosts]; // Add newPost at the beginning
          console.log({ newPosts });
          return newPosts; // Return the new array to update the state
          // return getColumnPosts(newPosts); // Re-distribute posts into columns
        });
      }
    });

    // Cleanup the WebSocket connection when the component unmounts
    return () => {
      socketConnection.disconnect();
    };
  }, [eventUrlSlug, currentEventId]); // Rerun this effect when eventUrlSlug changes

  useEffect(() => {
    console.log("Updated ads and post :", postsAndAds);
    const columns = getColumnPosts();
    setColumnsPosts(columns);
  }, [posts]); // Rerun this effect when eventUrlSlug changes

  useEffect(() => {
    const injectScripts = (scripts) => {
      scripts.forEach((script) => {
        if (script.on_off === "on" && !insertedScriptIds.includes(script.id)) {
          const scriptTag = document.createElement("script");
          scriptTag.innerHTML = script.script; // Set the script content
          scriptTag.type = "text/javascript";

          if (script.script_placement === "Header") {
            document.head.appendChild(scriptTag); // Inject into <head> section
          } else if (script.script_placement === "Footer") {
            document.body.appendChild(scriptTag); // Inject into <body> (footer)
          }

          // Track the script as inserted
          setInsertedScriptIds((prev) => [...prev, script.id]);
        }
      });
    };

    // Check if eventResponse.data.script_ids exists and call the function to inject scripts
    if (scripts.length > 0) {
      injectScripts(scripts);
    }
  }, [scripts]); // Trigger this effect when the scripts are updated

  const timeAgo = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(date)) / 1000);

    // Calculate the difference in various units
    const seconds = diffInSeconds;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30); // Approximate months as 30 days
    const years = Math.floor(months / 12);

    // Determine the appropriate time difference format
    if (years > 0) return `${years} year${years > 1 ? "s" : ""} ago`;
    if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
    if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    if (seconds > 0) return `${seconds} second${seconds > 1 ? "s" : ""} ago`;

    return "Just now";
  };

  const openPostModal = (post) => {
    setSelectedPost(post);
    showModal("postModal");
    // console.log({ media });
  };

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!event) {
    return <div>Loading...</div>;
  }

  if (!event || !currentEventId) {
    return <div>Event not found!</div>;
  }

  // Format event date and other details if necessary
  const formattedEventDate = new Date(event.event_date).toLocaleDateString(
    "en-GB",
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }
  );

  // Helper function to handle image errors and fallback
  const handleImageFallback = (e) => {
    // Fallback image URL
    const fallbackImage = "/assets/img/image-holder.jpg";
    // Update the source of the image element that triggered the error
    e.target.src = fallbackImage;
  };

  return (
    <div className="social-wall-main">
      <Helmet>
        <title>{event.page_title}</title>
        <meta name="description" content={event.page_description} />
        <meta name="keywords" content={event.page_keywords} />
        <link rel="canonical" href={eventPageUrl} />
        <link
          rel="apple-touch-icon"
          href={event.brand_social_share_image_url}
        />
      </Helmet>
      <nav
        className="navbar navbar-expand-md fixed-top text-light d-flex justify-content-center align-items-end align-items-sm-center flex-column p-3"
        style={{
          backgroundColor: event.top_brand_color,
        }}
      >
        <div className="logo position-absolute start-0 ms-3">
          <img
            src={event.brand_custom_logo_url || "/assets/img/image-holder.jpg"}
            alt={event.page_title}
            style={{ maxHeight: 50 }}
            className="img-fluid d-inline-block align-top"
            onError={handleImageFallback}
          />
        </div>
        <div
          className="text fs-50 fw-bolder"
          style={{
            color: event.top_banner_text_color,
          }}
        >
          {event.top_banner_text ? event.top_banner_text : "Sample text"}
        </div>
      </nav>

      <main className="container-fluid mb-3" role="main">
        <div className="row" id="posts-container">
          {columnsPosts.map((column, colIndex) => (
            <div
              key={colIndex}
              className={`col-12 col-sm-6 col-md-4 col-lg-3 posts-container-column`}
              id={`posts-container-${colIndex + 1}`}
            >
              {column.map((post, postIndex) => (
                <div key={postIndex} className="card position-relative">
                  <div className="position-relative">
                    {/* Media - Image or Video */}
                    {post.is_ads ? (
                      // If it's an ad, wrap the image/video in a Link to the ad URL
                      <Link
                        to={post.ad_url ? post.ad_url : "#"}
                        target={post.ad_url ? "_blank" : ""}
                        rel="noopener noreferrer"
                      >
                        {post.media_file_type === "image" ? (
                          <img
                            src={
                              post.thumbnail_media_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            className="card-img-top img-fluid"
                            alt="Ad Image"
                            onError={handleImageFallback}
                          />
                        ) : (
                          <>
                            <img
                              src={
                                post.thumbnail_media_url ||
                                "/assets/img/image-holder.jpg"
                              }
                              className="card-img-top img-fluid"
                              alt="Ad Image"
                              onError={handleImageFallback}
                            />
                            <div
                              className="position-absolute top-50 start-50 translate-middle cursor-pointer"
                              style={{ zIndex: 10 }}
                            >
                              <i
                                className="fa fa-play-circle text-white fs-1 shadow cursor-pointer"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </>
                        )}
                      </Link>
                    ) : (
                      // Regular posts - open modal on click
                      <>
                        {post.media_file_type === "image" ? (
                          <img
                            src={
                              post.thumbnail_media_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            className="card-img-top img-fluid"
                            alt="Post Image"
                            onClick={() => openPostModal(post)}
                            onError={handleImageFallback}
                          />
                        ) : (
                          <>
                            <img
                              src={
                                post.thumbnail_media_url ||
                                "/assets/img/image-holder.jpg"
                              }
                              className="card-img-top img-fluid"
                              alt="Post Image"
                              onClick={() => openPostModal(post)}
                              onError={handleImageFallback}
                            />
                            <div
                              className="position-absolute top-50 start-50 translate-middle cursor-pointer"
                              style={{ zIndex: 10 }}
                              onClick={() => openPostModal(post)}
                            >
                              <i
                                className="fa fa-play-circle text-white fs-1 shadow cursor-pointer"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  <div className="card-body">
                    <div className="form-text" dir="auto" tabIndex="0">
                      {post.caption || ""}
                      <i className="fa fa-heart-o me-2" aria-hidden="true"></i>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="form-text" dir="auto" tabIndex="0">
                        {post.person_name || ""}
                      </div>
                      <div className="form-text" dir="auto" tabIndex="0">
                        <i
                          className="fa fa-facebook-square fs-4"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* QR Code and Create Post text */}
        <div
          className="qr-code-container position-fixed bottom-0 left-0 mb-4 ms-4 p-2 rounded-3 bg-dark"
          style={{ zIndex: 99999 }}
        >
          {/* <img
            src="https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg" // Replace with the path to your QR code image
            alt="QR Code"
            className="rounded bg-white p-1 qr-code img-fluid"
            style={{ maxWidth: "100px", height: "auto" }}
          /> */}

          {/* QR Code generated dynamically */}
          <QRCodeCanvas
            value={eventFormUrl} // The URL you want to encode
            size={100} // Adjust the size as needed
            className="rounded bg-white p-1 qr-code img-fluid"
            style={{ maxWidth: "100px", height: "auto", zIndex: 99999 }}
          />
          <p className="create-post-text qr-code-text text-light text-center mb-0 mt-0 fw-bold">
            Scan Me
          </p>
        </div>

        <div
          className="modal fade"
          id="postModal"
          tabIndex="-1"
          aria-labelledby="postModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="d-flex justify-content-end p-2">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  {/* <i className="fa fa-times-circle fs-4 text-secondary"></i> */}
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2">
                    {selectedPost.media_file_type == "image" ? (
                      <img
                        src={selectedPost.media_url}
                        className="img-fluid rounded"
                        alt="Sample Image"
                        onError={handleImageFallback}
                      />
                    ) : (
                      <video
                        id="player"
                        className="w-100 rounded shadow-sm"
                        controls
                        src={selectedPost.media_url}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "60vh",
                        }}
                      ></video>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex align-items-center mb-3">
                      <i className="fa fa-twitter text-primary me-2 fs-5"></i>
                      <p className="mb-0">{selectedPost.person_city}</p>
                      <a
                        href="https://www.tiktok.com/player/v1/7448944345257921814"
                        className="ms-auto text-muted small text-decoration-none"
                        target="_blank"
                        rel="nofollow noopener"
                      >
                        {timeAgo(selectedPost.created_at)}
                      </a>
                    </div>
                    <p className="text-dark mb-2">{selectedPost.person_name}</p>
                    <p className="text-muted small mb-3">
                      {selectedPost.caption}
                    </p>
                    <div className="d-flex gap-2">
                      <a
                        className="btn btn-info btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-facebook text-white fs-5"></i>
                      </a>
                      <a
                        className="btn btn-primary btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-twitter text-white fs-5"></i>
                      </a>
                      <a
                        className="btn btn-danger btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-linkedin text-white fs-5"></i>
                      </a>
                      <a
                        className="btn btn-success btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-link text-white fs-5"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="no-posts"
          className="text-center text-muted"
          style={{ display: posts.length === 0 ? "block" : "none" }}
        >
          <p>No posts available at the moment. Check back later!</p>
        </div>
      </main>

      <div
        className="fixed-bottom text-light d-flex justify-content-center align-item-center flex-column p-3"
        style={{ backgroundColor: event.bottom_brand_color }}
      >
        <div
          className="text text-center bottom-banner-text"
          style={{
            color: event.bottom_banner_text_color,
          }}
        >
          <span className="fs-3 fw-bolder bottom-banner-main-text">
            {event.bottom_banner_text
              ? event.bottom_banner_text
              : "Sample text"}
          </span>
          {event.contact_information === "on" && (
            <>
              <br />
              {event.company_name} / {event.phone_number} / {event.website_url}
            </>
          )}
          {(event.copyright === "on" || event.legal === "on") && (
            <>
              <br />
            </>
          )}
          {event.copyright === "on" && (
            <>© Copyright 2025. Big Screen Social.</>
          )}
          {event.legal === "on" && <> All Rights Reserved</>}
        </div>
        <div className="logo position-absolute end-0 me-3 cta-url-button-base">
          <Link
            to={event.cta_url ? event.cta_url : "#"}
            target={event.cta_url ? "_blank" : ""}
            rel="noopener noreferrer"
          >
            <button
              type="button"
              className="btn btn-dark btn-round btn-lg cta-button"
              style={{
                backgroundColor: event.cta_button_color,
                color: event.cta_button_text_color,
                borderColor: event.cta_button_color,
              }}
            >
              {event.cta_text ? event.cta_text : "Sample text"}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventDetail;
